import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_BALANCE_CORRECTIONS = Symbol('balance-corrections');

export const ADMIN_BALANCE_CORRECTIONS_LIST_ROUTE_NAME = Symbol('admin.balance-corrections.list');

export const BALANCE_CORRECTIONS_LIST_API_URL = 'admin/affiliate_cashouts/adjustment_history/list';
export const BALANCE_CORRECTIONS_DOWNLOAD_REPORT_URL = 'admin/affiliate_cashouts/adjustment_history/download_report';
export const BALANCE_CORRECTIONS_LIST_QUERY_KEY = 'balance-corrections.list';
export const BALANCE_CORRECTIONS_DOWNLOAD_REPORT_MUTATION_KEY = 'balance-corrections.download-report';

export const BALANCE_CORRECTIONS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_ADMIN_BALANCE_ADJUSTMENTS_HISTORY_SHOW),
  DOWNLOAD_LIST: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_ADMIN_BALANCE_ADJUSTMENTS_HISTORY_DOWNLOAD),
};
